export default __webpack_public_path__ + "static/media/instagramLogo.abdffe59.jpg";